import { ServiceProvider } from "@RequestFormV2/sections/Service/context";
import FreightModeSection from "@RequestFormV2/sections/Service/components/FreightModeSection";
import ServiceLevelSection from "@RequestFormV2/sections/Service/components/ServiceLevelSection";
import RequirementsSection from "@RequestFormV2/sections/Service/components/RequirementsSection";
import "./Service.scss";

export default function Service() {
  return (
    <ServiceProvider>
      <FreightModeSection />
      <ServiceLevelSection />
      <RequirementsSection />
    </ServiceProvider>
  );
}
